import React from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import {
    initAxiosInterceptors,
    ModalProvider,
    Modals,
    PrimaryModal,
    PrimaryModalProvider,
    SecondaryModalProvider,
    SecondaryModal,
    DetailModalProvider,
    DetailModal,
    ModalMainProvider,
} from "./utils";
import reportWebVitals from "./reportWebVitals";
import {store} from "./store";
import {ScrollToTop} from "./components";
import "./assets/styles/index.scss";
import "./assets/styles/global.scss";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/keyboard";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/zoom";

initAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <ModalProvider>
            <PrimaryModalProvider>
                <SecondaryModalProvider>
                    <DetailModalProvider>
                        <Provider store={store}>
                            <ModalMainProvider>
                                <ScrollToTop/>
                                <App/>
                                <DetailModal/>
                                <Modals/>
                                <PrimaryModal/>
                                <SecondaryModal/>
                            </ModalMainProvider>
                        </Provider>
                    </DetailModalProvider>
                </SecondaryModalProvider>
            </PrimaryModalProvider>
        </ModalProvider>
    </BrowserRouter>,
);

reportWebVitals();
